import { Search } from "lucide-react";

type SearchStubProps = {
  collapsed?: boolean;
};

export function SearchStub({ collapsed }: SearchStubProps) {
  return (
    <div
      className={`mx-3 mb-2 flex items-center gap-2 rounded-md border border-ink/10 bg-paper text-ink-4 ${
        collapsed ? "justify-center px-2 py-2" : "px-3 py-2"
      }`}
      tabIndex={-1}
      aria-hidden="true"
    >
      <Search size={14} className="shrink-0" />
      {!collapsed && (
        <span className="text-[13px]">Search...</span>
      )}
    </div>
  );
}
